import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ReplayIcon from '@mui/icons-material/Replay';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles((theme) => ({
  retryContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#2a2a2a',
    borderRadius: 8,
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  message: {
    color: '#ff6b6b',
    marginRight: theme.spacing(2),
    fontFamily: 'Poppins, sans-serif',
    fontSize: '0.9em',
  },
  retryButton: {
    backgroundColor: '#FFC629',
    color: '#000000',
    '&:hover': {
      backgroundColor: '#e0b025',
    },
    marginRight: theme.spacing(1),
    textTransform: 'none',
    fontFamily: 'Raleway, sans-serif',
  },
  cancelButton: {
    color: '#808080',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#a0a0a0',
    },
    textTransform: 'none',
    fontFamily: 'Raleway, sans-serif',
  },
  attemptText: {
    color: '#808080',
    fontSize: '0.8em',
    marginLeft: theme.spacing(1),
    fontFamily: 'Raleway, sans-serif',
  },
}));

const RetryMessage = ({
  message,
  onRetry,
  onCancel,
  attempt = 1,
  maxAttempts = 3
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.retryContainer}>
      <Typography className={classes.message}>
        {message}
      </Typography>
      <Button
        className={classes.retryButton}
        onClick={onRetry}
        disabled={attempt > maxAttempts}
        startIcon={<ReplayIcon />}
      >
        Retry
      </Button>
      <Button
        className={classes.cancelButton}
        onClick={onCancel}
        startIcon={<CloseIcon />}
      >
        Cancel
      </Button>
      {attempt > 1 && (
        <Typography className={classes.attemptText}>
          Attempt {attempt} of {maxAttempts}
        </Typography>
      )}
    </Box>
  );
};

export default RetryMessage; 